import moment from 'moment';

export const getStudyPeriod = (startDate, days) => {
  const start = (typeof startDate === 'string'
    ? moment(startDate, 'YYYY-MM-DD', true)
    : moment(startDate || undefined)).startOf('day');
  if (!start.isValid() || !Number.isInteger(days) || days <= 0) {
    throw new Error('A valid study start date and duration are required.');
  }
  return {
    start_date: start.format('YYYY-MM-DD'),
    end_date: start.clone().add(days, 'days').format('YYYY-MM-DD'),
    days,
  };
};

export const getEpubocAssignmentPeriod = (credits, startDate, quantity = 1) => {
  const counts = { 14: 0, 31: 0 };
  (credits || []).forEach((credit) => {
    if (credit.book_code === 'EPUBOC' && [14, 31].includes(Number(credit.days))) {
      counts[Number(credit.days)] += Math.max(0, Number(credit.unused_cnt) || 0);
    }
  });
  if (counts[14] + counts[31] < quantity) {
    throw new Error('Not enough online study credits are available.');
  }
  const period = getStudyPeriod(startDate, counts[14] > 0 ? 14 : 31);
  // A mixed batch uses automatic selection; the backend computes each
  // student's end date from the shared start date and their consumed credit.
  if (counts[14] > 0 && counts[14] < quantity) period.days = null;
  return period;
};
